<div class="flex-col flex">
    <cb-table *cbWaitFor="lots" class="cb-margin-top cb-margin-bottom-3x" [loaded]="loaded">
        <thead cbTableHead>
            <tr>
                <td>Lot #</td>
                <td>Lot Type</td>
                <td>Build Type</td>
                <td>Land Price</td>
                <td>Build Price</td>
                <td>Sell Price</td>
                <td>Margin</td>
                <td>Cost to Date</td>
                <td>Cost to Complete</td>
                <td>Final Margin</td>
                <td></td>
            </tr>
        </thead>
        <tbody cbTableBody>
            @for (lot of lots | cbSortByPipe: 'lotNumber' : 'asc'; track lot) {
                <tr cbTableRow>
                    <cb-td-text [value]="lot.lotNumber"></cb-td-text>
                    <td>{{ lotTypeDisplay(lot.lotType) }}</td>
                    <td>
                        {{ LOT_TYPE_ENUM[lot.lotType] }}
                        @if (lot.buildType?.label) {
                            <span>({{ lot.buildType?.code }})</span>
                        }
                        <br />
                    </td>
                    <td>{{ lot.landPrice | cbCurrency: 'addGst' }} (Inc Gst)</td>
                    <cb-td-currency [value]="lot.buildPrice"></cb-td-currency>
                    <td>{{ lot.sellPrice | cbCurrency: 'addGst' }} (Inc Gst)</td>
                    <cb-td-currency [value]="lot.margin"></cb-td-currency>
                    <cb-td-currency [value]="lot.costsToDate"></cb-td-currency>
                    <cb-td-currency [value]="lot.costsToComplete"></cb-td-currency>
                    <cb-td-currency [value]="lot.finalMargin"></cb-td-currency>
                    <td cbTableStickyCol="end" cbTableShrinkCol>
                        <button [matMenuTriggerFor]="menu" mat-icon-button>
                            <mat-icon class="cb-grey">more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            @if (lotPermissions.canView()) {
                                <button mat-menu-item (cbClick)="viewLot(lot)">
                                    <mat-icon class="cb-grey">pageview</mat-icon>
                                    &nbsp; View Lot
                                </button>
                            }
                        </mat-menu>
                    </td>
                </tr>
            }
            @if (lots?.length < 1 && loaded) {
                <tr>
                    <td colspan="11">
                        <mat-icon class="mat-accent">info</mat-icon>
                        &nbsp;No Lots have been added to this Release Stage
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
</div>
